import React from "react";
import "./Certs.css";

const Certs = ({certData}) => {
  return (
    <div className="certificationWrapper">
      <img className="certImages" src={certData && certData.AWS1.src} alt={certData && certData.AWS1.alt} />
      <img className="certImages" src={certData && certData.AWS2.src} alt={certData && certData.AWS2.alt} />
      <img className="certImages" src={certData &&certData.AWS4.src} alt={certData && certData.AWS4.alt} />
      <img className="certImages" src={certData && certData.AZU5.src} alt={ certData && certData.AZU5.alt} />
      <img className="certImages" src={certData && certData.LIN6.src} alt={certData && certData.LIN6.alt} />
      <img className="certImages" src={certData && certData.AWS3.src} alt={certData && certData.AWS3.alt} />
      <img className="certImages" src={certData && certData.CIW.src} alt={certData && certData.CIW.alt} />
    </div>
  );
};

export default Certs;
